/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setHeaderTransform.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * 初期設定
 */
const html = document.documentElement;
let body = document.body;
let siteMV = document.getElementById("mv");
let header = document.getElementsByTagName("header")[0];
let siteHinner = document.querySelector(".site-header__inner");
let globalNav = document.querySelector(".globalNav");
let globalNav__nav = document.querySelector(".globalNav .nav");
let footer = document.getElementById("footer");
let siteHinnerLeft = 0;
let globalNavLeft = 0;
let globalNavLeftPosition = 0;

/**
 * スクロール上下判定
 */
let sc = (function () {
  let scrollElement = 'scrollingElement' in document ? document.scrollingElement : document.documentElement;
  let scrollPoint, prePoint, flag;
  return function () {
    scrollPoint = scrollElement.scrollTop;
    flag = prePoint > scrollPoint ? true : false;
    prePoint = scrollPoint;
    return flag;
  }
})();

//メインビジュアルを超えた時にヘッダーを変形する
let mv = (function () {
  let siteMVHeight = siteMV.clientHeight - header.clientHeight;
  return window.pageYOffset > siteMVHeight ? true : window.pageYOffset < siteMVHeight ? false : null;
})

//ヘッダーの高さを超えた時にヘッダーを変形する
let headerHeight = (function () {
  let position = header.clientHeight;
  return window.pageYOffset > position ? true : window.pageYOffset < position ? false : null;
})

//スクロールアロー表示・非表示（上矢印）
let scrollArrowTop = (function () {
  let siteMVHeight = siteMV.clientHeight / 4;
  return window.pageYOffset > siteMVHeight ? true : window.pageYOffset < siteMVHeight ? false : null;
})

//スクロールアロー表示・非表示（下矢印）
let scrollArrowBottom = (function () {
  let documentHeight = document.body.clientHeight;
  let windwHeight = window.innerHeight;
  let footerHeight = footer.clientHeight;
  return window.pageYOffset > documentHeight - windwHeight - footerHeight + 220 ? true : window.pageYOffset < footerHeight ? false : null;
})

//globalNavの位置を調整
let globalNavPosition = (function () {
  siteHinnerLeft = siteHinner.getBoundingClientRect().left;
  globalNavLeft = globalNav.getBoundingClientRect().left;
  globalNavLeftPosition = globalNavLeft - siteHinnerLeft;
})

/**
 * ヘッダー変形
 */
const setHeaderTransform = () => {
  const transform = () => {
    if (window.innerWidth > 1280) {
      headerHeight() ? html.classList.add('--h-transform') : html.classList.remove('--h-transform');
      headerHeight() ? globalNav__nav.style.transform = "translateX(" + globalNavLeftPosition + "px)" : globalNav__nav.style.transform = "translateX(0)";
    }
  }
  const resizeInit = () => {
    if (window.innerWidth < 1280) {
      html.classList.remove('--h-transform');
      globalNav__nav.style.transform = "translateX(0)";
    }
  }
  window.addEventListener("scroll", transform);
  window.addEventListener("DOMContentLoaded", () => {
    globalNavPosition();
    transform();
  });
  window.addEventListener("resize", () => {
    globalNavPosition();
    transform();
    resizeInit();
  });
}

/**
 * ActionTo.
 */
export {
  setHeaderTransform
}